import finlandFlag from "../../assets/emojione_flag-for-finland.svg"
import swedenFlag from "../../assets/emojione_flag-for-sweden.svg"
import gbrFlag from "../../assets/emojione_flag-for-united-kingdom.svg"

import React, { useEffect, useState } from "react"
import i18next from "i18next"
import { useTranslation } from "react-i18next"

type LanguageOption = "en" | "sv" | "fi"


export function LanguageSelector() {
  const [language, setLanguage] = useState(i18next.language)
  const { i18n } = useTranslation()

  function handleLanguageChange(code: LanguageOption) {
    setLanguage(code)
    i18next.changeLanguage(code)
  }

  useEffect(() => {
    document.body.dir = i18n.dir()
  }, [i18n,i18n.language])
  return(
    <div className="flex flag-wrapper">
      <button className="flag-btn" onClick={() => handleLanguageChange("sv")} disabled={(language === "sv")? true:false}><img id="sv" className="flag" src={swedenFlag} alt="Flag of Sweden"></img></button>
      <button className="flag-btn" onClick={() => handleLanguageChange("fi")} disabled={(language === "fi")? true:false}><img className="flag" src={finlandFlag} alt="Flag of Finland"></img></button>
      <button className="flag-btn" onClick={() => handleLanguageChange("en")} disabled={(language === "en")? true:false}><img className="flag" src={gbrFlag} alt="Flag of the United Kingdom"></img></button>
    </div>
  )
  
}